import { jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useRef } from "react";
import { useMe } from "@crehana/auth";
import { CREHANA_DOMAIN_PRD } from "@crehana/constants";
import { getUserDistinctId, parseQueryStrings } from "@crehana/utils";
function register({ user, countryPrefix, countryCode }) {
    if ("u" < typeof window) return;
    const { distinctId } = getUserDistinctId();
    const queryParams = parseQueryStrings(window.location.search);
    const { referrer } = document;
    const payload = {
        query_params: queryParams,
        url: window.location.href,
        user_id: user?.originalId,
        distinct_id: distinctId,
        referrer,
        iso: countryCode || countryPrefix || ''
    };
    const isDirect = !referrer;
    const isOrganic = referrer && !referrer.includes(CREHANA_DOMAIN_PRD) && !referrer.includes('creha.co') && !referrer.includes('localhost') && !referrer.includes('127.0.0.1');
    const forceSend = !!queryParams?.forceChannelRegister;
    if (isDirect || isOrganic || forceSend) fetch('/api/v3/channel-register/', {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(payload)
    }).then(()=>{
        console.log('Success to send data to channels endpoint');
    }).catch((error)=>{
        console.log('Error to send data to channel endpoint', error);
    });
}
const Channels = ({ children, countryPrefix, countryCode })=>{
    const done = useRef(false);
    const { me, loading, error } = useMe();
    useEffect(()=>{
        if (!loading && !error && !done.current) {
            done.current = true;
            register({
                user: me,
                countryCode: countryCode || countryPrefix || ''
            });
        }
    }, [
        loading,
        me,
        error,
        countryCode,
        countryPrefix
    ]);
    return /*#__PURE__*/ jsx(Fragment, {
        children: children
    });
};
const Channels_Channels = Channels;
export default Channels_Channels;
export { Channels, register };
